import { useState, useEffect, useReducer } from 'react';
import "../styles/loginFormStyle.css";
import Login from '../services/Login';
import { SaveSession, SaveLocal, RedirectionByScreen } from '../helpers/Helpers';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { FaUserAlt } from "react-icons/fa";
import AzulLogo from "../files/logotransp.png";
import Button from '@mui/material/Button';
import format from 'date-fns/format';
import jwt from 'jwt-decode';
import { BiShow, BiHide } from "react-icons/bi";
import GetUser from '../services/GetUser';
import ControlUser from '../components/Modals/ControlUser';
import axios from 'axios'
import { useNavigate } from 'react-router-dom';
import { decrypt, encrypt } from '../helpers/Helpers';

function LoginForm() {

    const [error, setError] = useState(false);
    const [userAllow, setuserAllow] = useState(false);
    const [attemptsRemaining, setAttemptsRemaining] = useState(null);
    const [isBlocked, setIsBlocked] = useState(false);
    const [showPass, setShowPass] = useState(false);
    const [usuario, setUsuario] = useState();
    const [openUserModal, setOpenUserModal] = useState(false);
    const [windowSize, setWindowSize] = useState(getWindowSize());

    const navigate = useNavigate();

    //FORMDATA REDUCER
    const formReducer = (state, event) => {
        return {
            ...state,
            [event.name]: event.value
        }
    }
    const [formData, setFormData] = useReducer(formReducer, {});

    const handleChange = event => {
        setFormData({
            name: event.target.name,
            value: event.target.value,
        });
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSubmit(e);
        }
    }

    //GET IP
    const [IP, setIP] = useState('');
    const getData = async () => {
        const res = await axios.get('https://geolocation-db.com/json/')
        //console.log(res.data);
        setIP(res.data.IPv4)
    }

    //GET WINDOW SIZE
    function getWindowSize() {
        const { innerWidth, innerHeight } = window;
        return { innerWidth, innerHeight };
    }

    useEffect(() => {
        setWindowSize(getWindowSize());
        getData();
    }, []);


    //SEND FUNCTION
    const handleSubmit = (e) => {
        Login({ username: formData.user, password: formData.password, Session: format(new Date(), 'yyyy-MM-dd HH:mm:ss'), IP }).then(response => {

            if (response.Confirmado == 'RE') {
                let token = jwt(response.data);
                SaveSession(token, response);
                SaveLocal(token, response);
                sessionStorage.setItem('current', encrypt(response.data, process.env.REACT_APP_KEY));
                sessionStorage.setItem('crewCode', response.crewCode);
                navigate('/ChangeInitialPassword', { replace: true });
            } else if (response.Confirmado == 'RP') {
                //Reset Passwors, reinicio de clave obligatorio
                let token = jwt(response.data);
                SaveSession(token, response);
                SaveLocal(token, response);
                sessionStorage.setItem('current', encrypt(response.data, process.env.REACT_APP_KEY));
                sessionStorage.setItem('crewCode', response.crewCode);
                navigate('/ResetPassword', { replace: true });
            } else if (response.Confirmado == 'Si') {
                //Acceso autorizado
                let token = jwt(response.data);
                SaveSession(token, response);
                SaveLocal(token, response);
                RedirectionByScreen(windowSize);
            } else if (response.Confirmado == 'No') {
                //Usuario bloqueado en sistema
                setIsBlocked(true);
                setAttemptsRemaining(null);
                setError('Usuario bloqueado. Contacta con supervisores para resolver la incidencia.');
                setuserAllow(response.data)
            } else if (response.Confirmado == 'MF') {
                //MFA
                let token = jwt(response.data);
                SaveSession(token, response);
                SaveLocal(token, response);
                sessionStorage.setItem('current', encrypt(response.data, process.env.REACT_APP_KEY));
                sessionStorage.setItem('crewCode', response.crewCode);
                navigate('/MFA', { replace: true })
            } else if (response.Confirmado == 'ERROR') {
                // Extraer intentos del mensaje si está disponible
                const attemptsRemain = response.attempts !== undefined ? response.attempts : null;

                if (attemptsRemain === 0) {
                    setIsBlocked(true);
                    setAttemptsRemaining(0);
                    setError('Usuario bloqueado tras 3 intentos fallidos. Contacta con supervisores para resolver la incidencia.');
                } else if (attemptsRemain && attemptsRemain > 0) {
                    setAttemptsRemaining(attemptsRemain);
                    setError(`Credenciales incorrectas. Te quedan ${attemptsRemain} intento${attemptsRemain > 1 ? 's' : ''}.`);
                    setIsBlocked(false);
                } else {
                    setError(response.data);
                }
            }
        })
        e.preventDefault();
    }

    //SHOW/HIDDE PASSWORD
    const VisibilityPass = () => {
        if (showPass == true) {
            setShowPass(false);
        } else {
            setShowPass(true);
        }
    }

    //GET USER SERVICE
    const GetTypeUser = () => {
        GetUser({ username: formData.user }).then((response) => {
            setUsuario(response)
            if (response[0]?.Confirmado == 'Si') {
                sessionStorage.setItem('crewCode', response[0]?.username);
                // Usar el token JWT devuelto por getUser.php
                if (response[0]?.data) {
                    localStorage.setItem('token', response[0].data);
                }
                navigate('/ChangePasswordbyEmail', { replace: true });
            } else {
                setOpenUserModal(true)
            }
        })
    }


    return (
        <div className="labs_page">
            {openUserModal && (
                <ControlUser data={usuario} open={openUserModal} onClose={() => setOpenUserModal()} />
            )}
            <div className="labs_card">

                {/* ── LEFT PANEL ── */}
                <div className="labs_card_left">
                    <img src={AzulLogo} className="labs_logo_img" alt="Azul Handling" />
                    <div className="labs_logo_text">
                        <span className="labs_brand_azul">AZUL</span>
                        <span className="labs_brand_handling">HANDLING</span>
                    </div>
                    <div className="labs_divider_line"></div>
                    <div className="labs_badge_pill">
                        <span>⚗</span><span>LABS</span>
                    </div>
                    <p className="labs_card_subtitle">TRAINING ENVIRONMENT</p>
                    <p className="labs_card_tagline">Acceso exclusivo para formación</p>
                </div>

                {/* ── RIGHT PANEL (form) ── */}
                <div className="labs_card_right">
                    <h2 className="labs_form_title">Iniciar sesión</h2>
                    <p className="labs_form_subtitle">Introduce tus credenciales de formación</p>

                    <Box sx={{ width: '100%', marginBottom: '16px' }}>
                        <TextField
                            fullWidth
                            id="login-user"
                            label="Usuario"
                            name='user'
                            value={formData.user || ""}
                            onChange={(e) => handleChange(e)}
                            onKeyPress={handleKeyPress}
                            autoComplete="off"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <FaUserAlt style={{ color: '#888' }} />
                                    </InputAdornment>
                                ),
                            }}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    '&.Mui-focused fieldset': { borderColor: '#1565c0' }
                                },
                                '& label.Mui-focused': { color: '#1565c0' }
                            }}
                            variant="outlined" />
                    </Box>

                    <Box sx={{ width: '100%', marginBottom: '8px' }}>
                        <TextField
                            fullWidth
                            id="login-password"
                            label="Contraseña"
                            name='password'
                            value={formData.password || ""}
                            type={showPass ? "text" : "password"}
                            onChange={(e) => handleChange(e)}
                            onKeyPress={handleKeyPress}
                            autoComplete="new-password"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <button onClick={VisibilityPass} id="show_pass">
                                            {showPass ? <BiHide id="lock_icon" /> : <BiShow id="lock_icon" />}
                                        </button>
                                    </InputAdornment>
                                ),
                            }}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    '&.Mui-focused fieldset': { borderColor: '#1565c0' }
                                },
                                '& label.Mui-focused': { color: '#1565c0' }
                            }}
                            variant="outlined" />
                    </Box>

                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        fullWidth
                        sx={{
                            backgroundColor: '#1565c0',
                            color: '#ffffff',
                            fontWeight: 700,
                            fontSize: '15px',
                            padding: '12px',
                            marginTop: '8px',
                            marginBottom: '4px',
                            borderRadius: '8px',
                            boxShadow: '0 4px 14px rgba(21, 101, 192, 0.35)',
                            '&:hover': {
                                backgroundColor: '#1976d2',
                                boxShadow: '0 6px 20px rgba(25, 118, 210, 0.45)',
                            }
                        }}
                    >
                        Iniciar sesión
                    </Button>

                    <div className="user_forgot">
                        {formData.user != undefined && formData.user !== "" && (
                            <button
                                className="labs_forgot_btn"
                                onClick={GetTypeUser}
                            >
                                ¿Olvidaste tu contraseña?
                            </button>
                        )}
                    </div>

                    <div id="error_message">
                        {Boolean(error) && <p id="passError">{error}</p>}
                    </div>

                    <p className="labs_version_label">v.3.0 · LABS</p>
                </div>

            </div>
        </div>
    );
}

export default LoginForm;
